<template>
  <div class="columns">
    <div class="column is-8 column-dashboard">
      <FunctionCards :hotpaths="hotpaths" />
    </div>

    <div class="column" style="margin: 0 auto;">
      <Notifications :projectID="project.id" />
    </div>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import FunctionCards from "@/components/FunctionCards.vue";
import Notifications from "@/components/Notifications.vue";

export default {
  name: "ProjectData",
  components: {
    FunctionCards,
    Notifications
  },
  apollo: {
    topTraffic: {
      query: gql`
        query topTraffic($query: TopTrafficQuery!) {
          topTraffic(query: $query) {
            new {
              hotpaths {
                percentage
                percentageChange
                newlyRanked
                rank
                rankChange
                samples
                name
                hash
              }
            }
          }
        }
      `,
      variables() {
        return {
          query: {
            projectID: this.project.id,
            topN: 10
          }
        };
      },
      /* eslint-disable */
      error(err) {
        this.$toast.open({
          message: err.message,
          type: "is-danger"
        });
      }
      /* eslint-enable */
    }
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      topTraffic: null
    };
  },
  computed: {
    hotpaths() {
      if (this.topTraffic) {
        return this.topTraffic.new.hotpaths;
      }
      return [];
    }
  }
};
</script>

<style>
.menu-list a.is-active {
  background-color: #0091d5;
  color: white;
}

.column-dashboard {
  overflow-y: scroll;
  max-height: 86vh;
}
</style>
